import { getPlayerProfile } from '../profile/profile.getters';
import { deliverChatbotMessage } from '../chatbot/chatbot.util';
import { generateReplicantChatbotPayload } from '../chatbot/messageTemplates';
import { getChatbotFlexMessage } from '../chatbot/flex/utils';
import { Feature } from '../analytics';
import { getLocale } from '../getters/user';
import { getCurrentEvolution } from '../pet/pet.getters';
import { State } from '../State';
import { SyncActionAPI } from '../utils/types';

/**
 * Deliver chatbot message when a friend request is accepted.
 *
 * `originFeature` / `originSubFeature` are propagated onto the OA payload so
 * that when the original requester taps the return-accept OA, their
 * `EntryFinal` reveals the in-game surface that started the flow. Source
 * them from the stored `FriendshipRequest` on accept paths, or from the
 * known invite attribution on the new-user-via-invite flow.
 */
export function deliverFriendRequestAcceptedMessage(
  args: {
    receiverId: string;
    acceptorState: State;
    now: number;
    originFeature?: string;
    originSubFeature?: string;
  },
  api: SyncActionAPI,
) {
  const profile = getPlayerProfile(
    args.acceptorState,
    args.acceptorState.publicProfile?.name,
    args.acceptorState.publicProfile?.photo,
  );

  const message = getChatbotFlexMessage({
    template: 'friendRequestAcceptedMessage',
    payload: generateReplicantChatbotPayload({
      feature: Feature.FRIENDS._,
      $subFeature: Feature.FRIENDS.ACCEPT,
      originFeature: args.originFeature,
      originSubFeature: args.originSubFeature,
      friendRequestSenderID: args.receiverId,
      friendRequestReceiverID: args.acceptorState.id,
    }),
    data: {
      sender: {
        photo: profile.photo,
        name: profile.name,
        species: getCurrentEvolution(args.acceptorState)?.species ?? 'ball',
      },
      locale: getLocale(args.acceptorState),
    },
  });

  deliverChatbotMessage(args.acceptorState, api, {
    receiverId: args.receiverId,
    message,
    channel: 'oa',
  });
}
